export default __webpack_public_path__ + "static/media/bg2.dcff517d.jpg";